import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as UserSettings from 'types/User/UserProfile/UserSettings';

export async function getUserSettings(): Promise<UserSettings.Type> {
	const settings = await UserSettings.getRecipeListValueScopeFromApi(UserSettings.create());
	const settingsAfter = await UserSettings.getRecipeNutrientColumnsFromApi(settings);

	return settingsAfter;
}

const rb = new ReducerBuilder<UserSettings.Type>();

export const userSettingsLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'userSettings/LoadedFromBackend'
);

export const setReduxUserSetting = rb.createActionForReducer(
	payloadReducer((x) => x),
	'userSettings/SET'
);
export const userSettingsReducer = rb.createReducer();
